import React from 'react'
import { Card, CardContent } from '@/components/ui/card'
import type { ConfigData } from '@/frontend/pages/CommandCenter/DigitalWorkers/types'

interface Props {
  config: ConfigData | null
}

const ConfigTab: React.FC<Props> = ({ config }) => {
  if (!config) {
    return (
      <Card>
        <CardContent>
          <p className="text-sm text-muted-foreground">Não foi possível carregar a configuração.</p>
        </CardContent>
      </Card>
    )
  }

  if (config.error) {
    return (
      <Card>
        <CardContent>
          <p className="text-sm text-muted-foreground">{config.error}</p>
        </CardContent>
      </Card>
    )
  }

  if (!config.config || Object.keys(config.config).length === 0) {
    return (
      <Card>
        <CardContent>
          <p className="text-sm text-muted-foreground">Nenhuma configuração encontrada.</p>
        </CardContent>
      </Card>
    )
  }

  return (
    <Card>
      <CardContent>
        <h2 className="text-lg font-semibold text-foreground mb-4">openclaw.json</h2>
        <pre className="text-xs leading-relaxed text-foreground bg-muted rounded-lg p-4 overflow-x-auto">
          {JSON.stringify(config.config, null, 2)}
        </pre>
      </CardContent>
    </Card>
  )
}

export default ConfigTab
